import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  container: {
    width: "100%",
    position: "fixed",
    bottom: 0,
    backgroundColor: "#f8f9fa",
    textAlign: "center",
    fontSize: "14px",
    color: "#6c757d",
    zIndex: 100,
    boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
  },
  text: {
    margin: 5,
    fontWeight: 400,
  },
});

export default function Footer() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <p className={classes.text}>
        &copy; {new Date().getFullYear()} Reliance Industries Limited. All
        rights reserved reserved.
      </p>
    </div>
  );
}
